import { render, staticRenderFns } from "./MPage.vue?vue&type=template&id=a389bf76&scoped=true&"
import script from "./MPage.vue?vue&type=script&lang=js&"
export * from "./MPage.vue?vue&type=script&lang=js&"
import style0 from "./MPage.vue?vue&type=style&index=0&id=a389bf76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a389bf76",
  null
  
)

export default component.exports